import type { Testimonial } from '../types/testimonial'
import { IMAGES } from './offer'

export const TESTIMONIAL_PHOTOS = {
  mirror: 'https://cdn.magicpatterns.com/uploads/8MEwti9QUZ48z4eGUP7NV9/t-05.png',
  couch: 'https://cdn.magicpatterns.com/uploads/hpRtuRujEVp8Ler22UDXwD/t-06.png',
  outdoor: 'https://cdn.magicpatterns.com/uploads/rPnnCByVx4jbqj34ehqbre/t-07.png',
  detail: 'https://cdn.magicpatterns.com/uploads/tzDeh8UXvZazCwCS3wBZxx/t-04.png',
  unboxing: 'https://cdn.magicpatterns.com/uploads/n16g5eYr6jxWhhoufHYneD/t-09.png',
  fence: 'https://cdn.magicpatterns.com/uploads/m4Ne2FJLJo2TjwbSXsj84D/t-08.png',
  chair: 'https://cdn.magicpatterns.com/uploads/igcDPkzTKhwaWd34URWCLb/t-03.png',
  table: 'https://cdn.magicpatterns.com/uploads/wGnD6Et35DwgkNXkcMU29p/t-02.png',
  held: 'https://cdn.magicpatterns.com/uploads/wNbxuLZSrQZGhTdcRemKqN/t-01.png'
} as const

export const makerTestimonials: Testimonial[] = [
  {
    id: 'ashley',
    name: 'Ashley T.',
    meta: 'Nashville, TN',
    metaKind: 'location',
    highlight: '5 compliments in 20 minutes',
    quote:
      'Obsessed is an understatement!! I was a bit nervous about the strap length, but it\u2019s literally perfect for crossbody wear. I wore it to the farmer\u2019s market this morning and got at least 5 compliments in the first 20 minutes. If you\u2019re on the fence, JUST GET IT. It\u2019s so much cuter in person than I expected!',
    image: TESTIMONIAL_PHOTOS.mirror,
    imageAlt:
      'Ashley taking a mirror selfie wearing the yellow crochet chicken bag crossbody over a grey sweater',
    caption: 'The mirror check before the farmer\u2019s market'
  },
  {
    id: 'megan',
    name: 'Megan R.',
    meta: 'Portland, OR',
    metaKind: 'location',
    highlight: 'First one finished in one Netflix night',
    quote:
      'Finally finished my first one while watching Netflix and honestly, the pattern is so easy to follow. I\u2019ve been crocheting for like 2 months and I didn\u2019t get stuck once. The \u201cno-sew\u201d parts are a total game changer. Already started a second one in white yarn for my bestie\u2019s birthday lol.',
    image: TESTIMONIAL_PHOTOS.couch,
    imageAlt:
      'Finished cream and rust crochet chicken bag sitting on a grey couch next to a basket of yarn and a coffee mug',
    caption: 'Finished on the couch, mid-episode'
  },
  {
    id: 'sarah',
    name: 'Sarah P.',
    meta: 'Austin, TX',
    metaKind: 'location',
    highlight: 'Sturdy enough for phone + keys',
    quote:
      'Look at this little guy in the sun! The texture of the yarn the pattern recommends is so sturdy. I was worried it would be too flimsy to actually hold my phone and keys, but it\u2019s super solid. Best $27 I\u2019ve spent on a hobby in a long time. The bundle value is actually insane.',
    image: TESTIMONIAL_PHOTOS.outdoor,
    imageAlt:
      'White crochet chicken bag hanging on a wooden garden fence in bright sunlight',
    caption: 'Out in the Texas sun'
  },
  {
    id: 'jessica',
    name: 'Jessica W.',
    meta: 'Chicago, IL',
    metaKind: 'location',
    highlight: 'Detail level: 10/10',
    quote:
      'The attention to detail in these patterns is 10/10. I\u2019ve bought patterns before that were just walls of text, but the photos in this vault are so helpful. Even the way the beak is shaped... it\u2019s just perfect. My daughter is going to lose her mind when she opens this on Christmas!',
    image: TESTIMONIAL_PHOTOS.detail,
    imageAlt:
      'Close-up of the wooden button closure and tight crochet stitches on a beige chicken bag',
    caption: 'The button detail, up close'
  }
]

export const proTestimonials: Testimonial[] = [
  {
    id: 'chloe',
    name: 'Chloe M.',
    meta: '@CrochetWithChloe',
    metaKind: 'handle',
    highlight: '45k views in 48 hours',
    quote:
      'I was struggling so hard to get views on my Reels until I used the \u201cViral Hooks\u201d bonus from this vault. My first video using the \u201cStitch With Me\u201d hook got 45k views in 48 hours! If you want to actually SELL your crochet and not just make it, you need this bundle. The hooks alone are worth the $27.',
    image: IMAGES.viralHooks,
    imageAlt:
      'Phone on a tripod in a craft room showing the list of viral content hooks for makers',
    caption: 'Bonus 4 — 50 Viral Reels / TikTok Hooks'
  },
  {
    id: 'hannah',
    name: 'Hannah B.',
    meta: 'The Cozy Stitch Co.',
    metaKind: 'shop',
    highlight: 'Reviews now mention the packaging',
    quote:
      'The Branding Kit is a total lifesaver. I used to just throw my plushies in a bag, but now with the professional Care Cards and Hang Tags, my customers feel like they\u2019re buying from a high-end boutique. My Etsy reviews specifically mention the \u201cbeautiful packaging\u201d now. It really leveled up my brand!',
    image: IMAGES.brandingKit,
    imageAlt: 'Handmade hang tags, care cards and thank you cards laid out on linen',
    caption: 'Bonus 5 — The Maker\u2019s Branding Kit'
  },
  {
    id: 'rebecca',
    name: 'Rebecca L.',
    meta: 'Denver, CO',
    metaKind: 'location',
    highlight: 'A complete business-in-a-box',
    quote:
      'I\u2019ve bought many pattern bundles before, but NOTHING compares to the \u201cCrochet Treasury.\u201d The sheer amount of patterns is overwhelming in a good way, and having the SEO secrets and the Price Calculator included makes this a complete business-in-a-box. It\u2019s the best investment I\u2019ve made for my hobby this year.',
    image: IMAGES.bundle,
    imageAlt:
      'The full digital bundle: hardcover treasury book, tablet, spiral SEO workbook, phone and branding cards',
    caption: 'The complete Modern Maker\u2019s Vault'
  },
  {
    id: 'amanda',
    name: 'Amanda K.',
    meta: 'Florida, US',
    metaKind: 'location',
    highlight: 'Raised prices 20% — sales went up',
    quote:
      'I realized I was losing money on every sale before using the \u201cPrice for Profit\u201d calculator. It opened my eyes to my hidden costs. I raised my prices by 20% following the psychology guide included, and my sales actually WENT UP because people perceive my work as more valuable now. Thank you, LLOYD!',
    image: IMAGES.calculator,
    imageAlt: 'Price for Profit pricing worksheet on a clipboard beside thread spools',
    caption: 'Bonus 3 — Price for Profit Calculator'
  }
]

export const communityTestimonials: Testimonial[] = [
  {
    id: 'brittany',
    name: 'Brittany S.',
    meta: 'Raleigh, NC',
    metaKind: 'location',
    highlight: 'First order shipped',
    quote:
      'My very first order went out today, packed with the Care Card from the Branding Kit. $48 for a bag that cost me $9 in yarn.',
    image: TESTIMONIAL_PHOTOS.unboxing,
    imageAlt: 'Crochet chicken bag packed in a shipping box with tissue paper, ready to mail',
    caption: 'Packed and shipped'
  },
  {
    id: 'kaitlyn',
    name: 'Kaitlyn D.',
    meta: 'Boise, ID',
    metaKind: 'location',
    highlight: 'Holds its shape all day',
    quote:
      'Made it in cream cotton for my sister. It held its shape through a full day out, and the head-shaping photos made it click instantly.',
    image: TESTIMONIAL_PHOTOS.fence,
    imageAlt: 'White crochet chicken bag hanging on a sunlit wooden fence',
    caption: 'Cream cotton version'
  },
  {
    id: 'nicole',
    name: 'Nicole H.',
    meta: 'Columbus, OH',
    metaKind: 'location',
    highlight: '3 hours start to finish',
    quote:
      'Chenille yarn version, done in three hours. This is the pattern I reach for when I need a last-minute gift that looks expensive.',
    image: TESTIMONIAL_PHOTOS.chair,
    imageAlt: 'White chenille crochet chicken bag hanging on a wooden chair',
    caption: 'The chenille speed-run'
  },
  {
    id: 'danielle',
    name: 'Danielle M.',
    meta: 'Savannah, GA',
    metaKind: 'location',
    highlight: 'Both sold in 4 days',
    quote:
      'Second one finished this week. I listed both on Etsy using the SEO keywords from Bonus 2 and they sold in four days.',
    image: TESTIMONIAL_PHOTOS.table,
    imageAlt: 'Cream crochet chicken bag on a wooden table beside a ball of yarn and a hook',
    caption: 'Listed and sold on Etsy'
  },
  {
    id: 'erin',
    name: 'Erin V.',
    meta: 'Salt Lake City, UT',
    metaKind: 'location',
    highlight: '6 sold before noon',
    quote:
      'I made a big batch for my craft fair table. Six sold before noon and half the line asked if I take custom orders.',
    image: TESTIMONIAL_PHOTOS.held,
    imageAlt: 'Maker holding up a large beige crochet chicken bag in her living room',
    caption: 'Craft fair batch'
  }
]
